// extracted by mini-css-extract-plugin
module.exports = {"DeleteButton":"CostumerListTable_DeleteButton__3KOw8","EditButton":"CostumerListTable_EditButton__2ThDJ"};